(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();
  var loadx_module_default = n;

  // src/js/components/image.js
  var _Image = class {
    static async init() {
      const images = window.Store.app.theBody.querySelectorAll(_Image.param.selector);
      if (!images.length) {
        return null;
      }
      if (!window.Store.components.image.lib_loaded) {
        await loadx_module_default.js("https://unpkg.com/vanilla-lazyload@17.5.0/dist/lazyload.min.js");
        window.Store.components.image.lib_loaded = true;
      }
    }
    static create() {
      let obj = new _Image();
      const element = new LazyLoad({
        elements_selector: _Image.param.selector,
        callback_loaded: (el) => {
          obj.notifyAncestor(el);
          window.Store.scrollbar.element.update();
        }
      });
      obj.element = element;
      return obj;
    }
    load(element) {
      LazyLoad.load(element, {
        callback_loaded: (el) => {
          this.notifyAncestor(el);
          window.Store.scrollbar.element.update();
        }
      });
    }
    notifyAncestor(element) {
      const ancestor = element.closest(_Image.param.component_selector);
      if (ancestor) {
        ancestor.classList.add(_Image.param.modifiers.is_loaded);
      }
    }
  };
  var Image = _Image;
  __publicField(Image, "param", {
    selector: ".js-lazy",
    component_selector: ".c-img",
    modifiers: {
      is_loaded: "is-loaded"
    }
  });
  function render() {
    Image.init().then(() => {
      window.Store.components.image.obj = Image.create();
    });
  }
  window.Store.components.image.render = render;
})();
